import { getMatchRateLevel } from "../../utils/colors";
import { formatPercentage } from "../../utils/formatters";
import styles from "./MatchRateBadge.module.css";

export interface MatchRateBadgeProps {
  rate: number;
}

export function MatchRateBadge({ rate }: MatchRateBadgeProps) {
  const level = getMatchRateLevel(rate);

  return (
    <span className={`${styles.badge} ${styles[level]}`}>
      {formatPercentage(rate)}
    </span>
  );
}
